import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/GroupSocialLink.module.css";
import clsx from "clsx";

const GroupSocialLink = ({
  className,
  facebookLink,
  linkedinLink,
  youtubeLink,
}) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <ul
      className={clsx(
        styles.listIcon,
        "d-flex list-unstyled mb-3 mt-3",
        className
      )}
    >
      {facebookLink && (
        <a href={facebookLink} target="_blank" rel={"no noreferrer"}>
          <li className={clsx(styles.iconSocial)}>
            <i className="fab fa-facebook-f"></i>
          </li>
        </a>
      )}
      {/* <li className={clsx(styles.iconSocial, "bg-primary")}>
        <a href={"#"}>
          <i className="fab fa-twitter"></i>
        </a>
      </li> */}
      {linkedinLink && (
        <a href={linkedinLink} target="_blank" rel={"no noreferrer"}>
          <li className={clsx(styles.iconSocial, "bg-info")}>
            <i className="fab fa-linkedin-in"></i>
          </li>
        </a>
      )}

      {youtubeLink && (
        <a href={youtubeLink} target="_blank" rel={"no noreferrer"}>
          <li className={clsx(styles.iconSocial, "bg-danger")}>
            <i className="fab fa-youtube"></i>
          </li>
        </a>
      )}
    </ul>
  );
};

/* required: display name */
GroupSocialLink.displayName = "GroupSocialLink";

/* required: props types */
GroupSocialLink.propTypes = {};

/* required: default props */
GroupSocialLink.defaultProps = {};

export { GroupSocialLink };
